import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Table.svg",
  "use": "Table.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Table.svg\"><path d=\"M51.0207,52.0209h-38a5,5,0,0,1-5-5v-30a5,5,0,0,1,5-5h38a5,5,0,0,1,5,5v30A5,5,0,0,1,51.0207,52.0209Zm-21-30h-17a1,1,0,0,0-1,1v5h18Zm0,10h-18v6h18Zm0,10h-18v5a1,1,0,0,0,1,1h17Zm22-19a1,1,0,0,0-1-1h-17v6h18Zm0,9h-18v6h18Zm0,10h-18v6h17a1,1,0,0,0,1-1Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol